enum ContactVerificationStatus {
  Unverified = "UNVERIFIED",
  Verified = "VERIFIED",
}

export default ContactVerificationStatus;
